<template>
  <v-app>
    <v-navigation-drawer app>
      <!-- -->
    </v-navigation-drawer>

    <v-main id="container">
      <v-app-bar dark>
        <img class="wx-logo mr-5" :src="require('../assets/xzslogo.png')" />
        <v-toolbar-title>达芬奇汽车上传系统</v-toolbar-title>
      </v-app-bar>
      <v-container fluid>
        <v-row dense>
          <v-col v-for="card in cards" :key="card.title" :cols="card.flex">
            <v-card @click="card.onClick">
              <v-img :src="card.src" class="card-img"></v-img>
              <div v-text="card.title" class="text-subtitle-1 pt-2 pb-2 pl-2 pr-2 text-center"></div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
// @ is an alias to /src
import { PageNames } from '../util/tool'

export default {
  name: 'Home',
  data() {
    // eslint-disable-next-line
    const _this = this
    return {
      cards: [
        {
          title: PageNames.dbas,
          flex: 6,
          src: require('../assets/index/audi_scroll_view.jpg'),
          onClick() {
            _this.$router.push('/imgu/dbas/ground/0')
          }
        },
        {
          title: PageNames.nav,
          flex: 6,
          src: require('../assets/index/nav_view.jpg'),
          onClick() {
            _this.$router.push('/imgu/nav/ground/0')
          }
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.card-img {
  height: 100px;
}
.wx-logo {
  height: 49px;
}
</style>
